// extracted by mini-css-extract-plugin
export default {"logoutBtn":"userIcon_logoutBtn__0U6wj"};